// 导入 login.ts 中的所有接口
import * as login from './login';
import * as users from './users';
import * as provider from './provider'

// 聚合导出（和 Pro 框架默认的 service 导出格式一致）
export default {
    login, users, provider
};